import React from "react";
import EventService from "@shared/services/EventService";
import Keyboard from "@shared/modules/utils/Keyboard";
import { debounce } from "@shared/utils";

export default class GlobalKeyboard extends React.Component {
    state = {
        keyboardProps: {},
        showKeyboard: false
    };

    updateState = (state) => {
        this.setState({...state})
    }

    debouncedStateUpdate = debounce(this.updateState, 100);

    componentDidMount() {
        this.eventShow = EventService.subscribe("keyboard.show", async ({ keyboardProps = {} } = {}) => {
            try {
                this.debouncedStateUpdate({ showKeyboard: true, keyboardProps });
            } catch (error) {
                console.error("could not show keyboard!!");
            }
        });

        this.eventHide = EventService.subscribe("keyboard.hide", () => {
            try {
                this.debouncedStateUpdate({ showKeyboard: false, keyboardProps: {} });
            } catch (error) {
                console.error("could not hide keyboard!!");
            }
        });
    }

    componentWillUnmount() {
        this.eventShow.remove();
        this.eventHide.remove();
    }

    render() {
        let { keyboardProps, showKeyboard } = this.state;
        return (
            <div className={`keyboard-wrapper ${showKeyboard ? "slideup" : "slidedown"}`}>
                {showKeyboard && <Keyboard key={keyboardProps.inputContext} {...keyboardProps} />}
            </div>
        );
    }
}
